import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { borderColor, borderRadius, borders, boxShadow, color, display, fontSize, fontWeight, overflow, space, style, textAlign, themeGet } from 'styled-system';
import { Classes } from '@blueprintjs/core';
import borderColors from './utils/borderColors';
import flex from './utils/flex';
import grid from './utils/grid';
import size from './utils/size';
import position from './utils/position';
const StyledCard = styled.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-kgsftc-0"
})(["&&{", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", "}"], borderColor, borderRadius, borders, boxShadow, display, color, display, fontSize, fontWeight, space, overflow, position, style({
  prop: 'overflowX'
}), style({
  prop: 'overflowY'
}), style({
  prop: 'transition'
}), textAlign, borderColors, flex, grid, size, ({
  theme,
  bg
}) => theme.name === 'dark' && css(["&.", "{background:", ";border:1px solid ", ";box-shadow:none;}"], Classes.CARD, themeGet(`colors.${bg}`, theme.colors.cardBackground), theme.colors.cardBorder));
const Card = /*#__PURE__*/React.forwardRef(({
  elevation = 0,
  interactive = false,
  showSkeleton,
  className,
  runningText,
  children,
  ...rest
}, ref) => /*#__PURE__*/React.createElement(StyledCard, _extends({
  ref: ref,
  className: classNames(Classes.CARD, className, {
    [`bp4-elevation-${elevation}`]: true,
    [Classes.RUNNING_TEXT]: runningText,
    [Classes.INTERACTIVE]: interactive,
    [Classes.SKELETON]: showSkeleton
  }),
  p: 0
}, rest), children));
export default Card;